import { API_APP_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'

export type PetAdditionalParty = {
  id?: string
  kanguro_policy_id: string
  name: string
  pet_type: string
  pet_birth_date: string
  breed_id: number
}

export async function fetchPetAdditionalParty(
  policyId: string,
): Promise<PetAdditionalParty | undefined> {
  const token = await getJwt()
  const params = new URLSearchParams({ policy_id: policyId })
  return apiRequest<PetAdditionalParty | undefined>(
    `${API_APP_PATH.PET_ADDITIONAL_PARTY}?${params.toString()}`,
    token,
    'GET',
    undefined,
    'app',
  )
}

export async function updatePetAdditionalParty(
  id: string,
  body: Partial<Omit<PetAdditionalParty, 'id' | 'kanguro_policy_id'>>,
): Promise<PetAdditionalParty> {
  const token = await getJwt()
  return apiRequest<PetAdditionalParty>(
    `${API_APP_PATH.PET_ADDITIONAL_PARTY}/${id}`,
    token,
    'PATCH',
    body,
    'app',
  )
}
